import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';
import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

export default function H() {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    // const ZA_SITE: string[] = ['za'];

    let cards: any = [
        {
            // img: `/responsive/picture/common-products/${ZA_SITE.includes(locale) ? '110' : '60'}w.png`,
            power: t('secH_card1_power'),
            title: t('secH_card1_title'),
            with: t('secH_card1_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/60w-portable-solar-panel',
                    ca: 'https://ca.ecoflow.com/products/60w-portable-solar-panel',
                    de: 'https://de.ecoflow.com/products/60w-portable-solar-panel',
                    za: 'https://za.ecoflow.com/products/110w-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/60w-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/60w-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/60w-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/60w-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/60w-portable-solar-panel',
                    nl: 'https://nl.ecoflow.com/products/60w-portable-solar-panel',
                    au: 'https://au.ecoflow.com/products/110w-solar-panel',
                    kr: 'https://kr.ecoflow.com/products/110w-portable-solar-panel',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '4478011113545',
                    ca: '7539941834906',
                    de: '8551057686863',
                    za: '7027755876561',
                    fr: '8468805484891',
                    eu: '8453648777559',
                    uk: '8434339938643',
                    it: '8438189392221',
                    es: '8465628135771',
                    au: '6734298185926',
                    kr: '7429921112233',
                    nl: '9935705309460',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998108401737',
                    ca: '43797586608282',
                    de: '46805156626767',
                    za: '41611171463377',
                    fr: '47199947358555',
                    eu: '47350405955927',
                    uk: '47336920416595',
                    it: '49181448044893',
                    es: '47334114361691',
                    au: '42994541494470',
                    kr: '44206195343529',
                    nl: '51194396934420',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card1_desc1'), t('secH_card1_desc2'), t('secH_card1_desc3')],
        },
        {
            // img: `/responsive/picture/common-products/${ZA_SITE.includes(locale) ? '160' : '110'}w.png`,
            power: t('secH_card2_power'),
            title: t('secH_card2_title'),
            with: t('secH_card2_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/110w-portable-solar-panel',
                    ca: 'https://ca.ecoflow.com/products/110w-portable-solar-panel',
                    de: 'https://de.ecoflow.com/products/110w-portable-solar-panel',
                    za: 'https://za.ecoflow.com/products/160w-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/110w-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/110w-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/110w-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/110w-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/110w-portable-solar-panel',
                    nl: 'https://nl.ecoflow.com/products/110w-portable-solar-panel',
                    au: 'https://au.ecoflow.com/products/160w-solar-panel',
                    kr: 'https://kr.ecoflow.com/products/160w-portable-solar-panel',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '4318647222345',
                    ca: '5511642644634',
                    de: '7530378625271',
                    za: '7027757023441',
                    fr: '7607009444066',
                    eu: '5450638196900',
                    uk: '6827746296000',
                    it: '7709732700401',
                    es: '7693956841694',
                    au: '6734298513606',
                    kr: '7429922750633',
                    nl: '9935696822548',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998109941833',
                    ca: '43725961199770',
                    de: '42386672877815',
                    za: '41611172741329',
                    fr: '47182914290011',
                    eu: '47202453782871',
                    uk: '47177828237651',
                    it: '48829001630045',
                    es: '47182969930075',
                    au: '42994544509126',
                    kr: '43800027037865',
                    nl: '51194369933588',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card2_desc1'), t('secH_card2_desc2'), t('secH_card2_desc3')],
        },
        {
            // img: `/responsive/picture/common-products/${ZA_SITE.includes(locale) ? '220w_bifacial' : '160w'}.png`,
            power: t('secH_card3_power'),
            title: t('secH_card3_title'),
            with: t('secH_card3_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/160w-portable-solar-panel',
                    ca: 'https://ca.ecoflow.com/products/160w-portable-solar-panel',
                    de: 'https://de.ecoflow.com/products/160w-portable-solar-panel',
                    za: 'https://za.ecoflow.com/products/220w-bifacial-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/160w-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/160w-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/160w-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/160w-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/160w-portable-solar-panel',
                    nl: 'https://nl.ecoflow.com/products/160w-portable-solar-panel',
                    au: 'https://au.ecoflow.com/products/220w-bifacial-solar-panel',
                    kr: 'https://kr.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '4605523198025',
                    ca: '6609119936666',
                    de: '7530380787959',
                    za: '7027754926289',
                    fr: '7607011868898',
                    eu: '6592824737956',
                    uk: '6827738628288',
                    it: '7709730308337',
                    es: '7693955072222',
                    au: '7236817223878',
                    kr: '7759732441257',
                    nl: '9935714353428',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40573832429641',
                    ca: '43762372739226',
                    de: '42386679103735',
                    za: '41630471913681',
                    fr: '47182916059483',
                    eu: '47202454372695',
                    uk: '47177829908819',
                    it: '48829029056861',
                    es: '47182981923163',
                    au: '42974087807174',
                    kr: '46679477059753',
                    nl: '51427564355860',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card3_desc1'), t('secH_card3_desc2'), t('secH_card3_desc3')],
        },
        {
            // img: `/responsive/picture/common-products/${ZA_SITE.includes(locale) ? '400w' : '220w_bifacial'}.png`,
            power: t('secH_card4_power'),
            title: t('secH_card4_title'),
            with: t('secH_card4_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    ca: 'https://ca.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    de: 'https://de.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    za: 'https://za.ecoflow.com/products/400w-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    nl: 'https://nl.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    au: 'https://au.ecoflow.com/products/400w-portable-solar-panel',
                    kr: 'https://kr.ecoflow.com/products/400w-portable-solar-panel',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6687135957065',
                    ca: '7539942064282',
                    de: '7576822055159',
                    za: '7027755253969',
                    fr: '7666208997602',
                    eu: '7265892434084',
                    uk: '7192785223872',
                    it: '7709724377329',
                    es: '7693952483550',
                    au: '7238909657286',
                    kr: '7429924946089',
                    nl: '9935714386196',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40573832495177',
                    ca: '43725934461082',
                    de: '42581963931895',
                    za: '41630472405201',
                    fr: '47182916944219',
                    eu: '47202454602071',
                    uk: '47177830629715',
                    it: '48829042753885',
                    es: '47182984544603',
                    au: '42994548211910',
                    kr: '41998639202473',
                    nl: '51427570286868',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card4_desc1'), t('secH_card4_desc2'), t('secH_card4_desc3')],
        },
    ];

    if (locale === 'au') {
        cards = [
            {
                img: '/responsive/picture/common-products/110W_portable_new.png',
                power: t('secH_card1_power'),
                title: t('secH_card1_title'),
                with: t('secH_card1_with'),
                link_more: 'https://au.ecoflow.com/products/110w-solar-panel',
                productId: '6734298185926',
                variantId: '42994541494470',
                descArr: [t('secH_card1_desc1'), t('secH_card1_desc2'), t('secH_card1_desc3')],
            },
            {
                img: '/responsive/picture/common-products/160W_portable_new.png',
                power: t('secH_card2_power'),
                title: t('secH_card2_title'),
                with: t('secH_card2_with'),
                link_more: 'https://au.ecoflow.com/products/ecoflow-nextgen-160w-portable-solar-panel',
                productId: '8088212930758',
                variantId: '43760119873734',
                descArr: [t('secH_card2_desc1'), t('secH_card2_desc2'), t('secH_card2_desc3')],
            },
            {
                img: '/responsive/picture/common-products/220W_portable_new.png',
                power: t('secH_card3_power'),
                title: t('secH_card3_title'),
                with: t('secH_card3_with'),
                link_more: 'https://au.ecoflow.com/products/220w-bifacial-solar-panel',
                productId: '7236817223878',
                variantId: '42974087807174',
                descArr: [t('secH_card3_desc1'), t('secH_card3_desc2'), t('secH_card3_desc3')],
            },
            {
                img: '/responsive/picture/common-products/400W_portable_new.png',
                power: t('secH_card4_power'),
                title: t('secH_card4_title'),
                with: t('secH_card4_with'),
                link_more: 'https://au.ecoflow.com/products/400w-portable-solar-panel',
                productId: '7238909657286',
                variantId: '42994548211910',
                descArr: [t('secH_card4_desc1'), t('secH_card4_desc2'), t('secH_card4_desc3')],
            },
        ];
    }
    if (['eu', 'uk', 'fr', 'it', 'es', 'de', 'nl'].includes(locale)) {
        cards = [
            {
                img: ``,
                power: t('secH_card1_power'),
                title: t('secH_card1_title'),
                with: t('secH_card1_with'),
                link_more: (() => {
                    const localMap: any = {
                        de: 'https://de.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                        fr: 'https://fr.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                        eu: 'https://eu.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                        uk: 'https://uk.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                        it: 'https://it.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                        es: 'https://es.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                        nl: 'https://nl.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                productId: (() => {
                    const localMap: any = {
                        de: '7576822055159',
                        fr: '7666208997602',
                        eu: '7265892434084',
                        uk: '7192785223872',
                        it: '7709724377329',
                        es: '7693952483550',
                        nl: '9935705309460',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        de: '47647198609743',
                        fr: '47182916944219',
                        eu: '47202454602071',
                        uk: '47177830629715',
                        it: '48829042753885',
                        es: '47182984544603',
                        nl: '51194396934420',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                descArr: [t('secH_card1_desc1'), t('secH_card1_desc2'), t('secH_card1_desc3')],
            },
            {
                img: ``,
                power: t('secH_card2_power'),
                title: t('secH_card2_title'),
                with: t('secH_card2_with'),
                link_more: (() => {
                    const localMap: any = {
                        de: 'https://de.ecoflow.com/products/160w-portable-solar-panel',
                        fr: 'https://fr.ecoflow.com/products/160w-portable-solar-panel',
                        eu: 'https://eu.ecoflow.com/products/160w-portable-solar-panel',
                        uk: 'https://uk.ecoflow.com/products/160w-portable-solar-panel',
                        it: 'https://it.ecoflow.com/products/160w-portable-solar-panel',
                        es: 'https://es.ecoflow.com/products/160w-portable-solar-panel',
                        nl: 'https://nl.ecoflow.com/products/160w-portable-solar-panel',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                productId: (() => {
                    const localMap: any = {
                        de: '7530380787959',
                        fr: '7607011868898',
                        eu: '6592824737956',
                        uk: '6827738628288',
                        it: '7709730308337',
                        es: '7693955072222',
                        nl: '9935696822548',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        de: '47647193301327',
                        fr: '47182916059483',
                        eu: '47202454372695',
                        uk: '47177829908819',
                        it: '48829029056861',
                        es: '47182981923163',
                        nl: '51194369933588',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                descArr: [t('secH_card2_desc1'), t('secH_card2_desc2'), t('secH_card2_desc3')],
            },
            {
                img: ``,
                power: t('secH_card3_power'),
                title: t('secH_card3_title'),
                with: t('secH_card3_with'),
                link_more: (() => {
                    const localMap: any = {
                        de: 'https://de.ecoflow.com/products/110w-portable-solar-panel',
                        fr: 'https://fr.ecoflow.com/products/110w-portable-solar-panel',
                        eu: 'https://eu.ecoflow.com/products/110w-portable-solar-panel',
                        uk: 'https://uk.ecoflow.com/products/110w-portable-solar-panel',
                        it: 'https://it.ecoflow.com/products/110w-portable-solar-panel',
                        es: 'https://es.ecoflow.com/products/110w-portable-solar-panel',
                        nl: 'https://nl.ecoflow.com/products/110w-portable-solar-panel',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                productId: (() => {
                    const localMap: any = {
                        de: '7530378625271',
                        fr: '7607009444066',
                        eu: '5450638196900',
                        uk: '6827746296000',
                        it: '7709732700401',
                        es: '7693956841694',
                        nl: '9935714353428',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        de: '47647185797455',
                        fr: '47182914290011',
                        eu: '47202453782871',
                        uk: '47177828237651',
                        it: '48829001630045',
                        es: '47182969930075',
                        nl: '51427564355860',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                descArr: [t('secH_card3_desc1'), t('secH_card3_desc2'), t('secH_card3_desc3')],
            },
            {
                img: ``,
                power: t('secH_card4_power'),
                title: t('secH_card4_title'),
                with: t('secH_card4_with'),
                link_more: (() => {
                    const localMap: any = {
                        de: 'https://de.ecoflow.com/products/60w-portable-solar-panel',
                        fr: 'https://fr.ecoflow.com/products/60w-portable-solar-panel',
                        eu: 'https://eu.ecoflow.com/products/60w-portable-solar-panel',
                        uk: 'https://uk.ecoflow.com/products/60w-portable-solar-panel',
                        it: 'https://it.ecoflow.com/products/60w-portable-solar-panel',
                        es: 'https://es.ecoflow.com/products/60w-portable-solar-panel',
                        nl: 'https://nl.ecoflow.com/products/60w-portable-solar-panel',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                productId: (() => {
                    const localMap: any = {
                        de: '7530382983415',
                        fr: '8468805484891',
                        eu: '8453648777559',
                        uk: '7122954420416',
                        it: '8438189392221',
                        es: '8465628135771',
                        nl: '9935714386196',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        de: '46896968958287',
                        fr: '47199947358555',
                        eu: '47350405955927',
                        uk: '47177831776595',
                        it: '49181448044893',
                        es: '47334114361691',
                        nl: '51427570286868',
                    };
                    return localMap[locale] || localMap.eu;
                })(),
                descArr: [t('secH_card4_desc1'), t('secH_card4_desc2'), t('secH_card4_desc3')],
            },
        ];
    }
    const [cardLists, setCardLists] = useState(locale === 'ca' ? [cards[1], cards[2], cards[3]] : [...cards]);

    const handleBuy = (card: any) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: t('secH_title'),
                product_name: card?.title || card?.productTitle || card?.skuTitle,
                price: card?.price,
                tag: card?.tag || 'none',
                quantity: 1,
                button_name: t('common_card_buy') || 'Buy Now',
            });
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            const { price, compareAtPrice, inventoryPolicy, inventoryQuantity, productId, variantId, variantImg, img, productTitle, skuTitle } = card;
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
                {
                    price,
                    compareAtPrice,
                    inventoryPolicy,
                    inventoryQuantity,
                    productId,
                    variantId,
                    variantImg,
                    img,
                    productTitle,
                    skuTitle,
                    quantity: 1,
                } as ItfEcoCartItem,
            ]);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
        }
    }, []);

    useEffect(() => {
        const tempArr = [...cardLists];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (res?.data?.handle) {
                            tempArr[k].link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                        }
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                        return resolve({ ...tempArr?.[k], ...res?.data });
                    } else {
                        console.error(res?.message);
                        return reject({ ...tempArr?.[k] });
                    }
                } catch (e) {
                    console.error(e);
                    return reject({ ...tempArr?.[k] });
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then((res: any) => {
                setCardLists(res);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="outdoor-recreation-H" className={`outdoor-recreation-H ${css['outdoor-recreation-H']}`}>
            <div className="ef-box">
                <Swiper className="cards swiper-box" effect="fade" spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                    {cardLists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            <EFPicture src={card?.variantImg || card?.img} alt={card?.productTitle || card?.skuTitle} />
                            <p className="card-title">{card?.productTitle || card?.skuTitle}</p>
                            <ul className="card-descs">
                                {card?.descArr?.map((desc: any, m: number) => (
                                    <li className="card-desc" key={`${k}_${m}`}>
                                        {desc}
                                    </li>
                                ))}
                            </ul>
                            <p className="card-works">{t('secH_card_works')}</p>
                            <p className="card-with">{card?.with}</p>
                            <div className="card-btns">
                                {card?.link_buy && locale === 'kr' ? (
                                    <div className="card-btn-cart">
                                        <button
                                            className={`kr-shop${
                                                Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? ' disabled' : ''
                                            }`}
                                            onClick={() =>
                                                (Number(card?.inventoryQuantity || 0) > 0 || card?.inventoryPolicy === 'continue') &&
                                                window.open(card?.link_buy, '_blank')
                                            }
                                        >
                                            {t('common_card_buy_new')}
                                        </button>
                                        <button
                                            className={`kr-add-cart${
                                                Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? ' disabled' : ''
                                            }`}
                                            onClick={() =>
                                                (Number(card?.inventoryQuantity || 0) > 0 || card?.inventoryPolicy === 'continue') && handleBuy(card)
                                            }
                                        >
                                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M16.1665 20C16.1665 21.3807 17.2858 22.5 18.6665 22.5C20.0472 22.5 21.1664 21.3807 21.1664 20C21.1664 18.6193 20.0472 17.5 18.6665 17.5C17.2858 17.5 16.1665 18.6193 16.1665 20ZM19.7056 20.017C19.7056 20.5692 19.2579 21.017 18.7057 21.017C18.1534 21.017 17.7057 20.5692 17.7057 20.017C17.7057 19.4647 18.1534 19.017 18.7057 19.017C19.2579 19.017 19.7056 19.4647 19.7056 20.017Z"
                                                    fill="currentColor"
                                                ></path>
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M6.1665 20C6.1665 21.3807 7.28578 22.5 8.66647 22.5C10.0472 22.5 11.1664 21.3807 11.1664 20C11.1664 18.6193 10.0472 17.5 8.66647 17.5C7.28578 17.5 6.1665 18.6193 6.1665 20ZM9.70565 20.017C9.70565 20.5692 9.25794 21.017 8.70566 21.017C8.15339 21.017 7.70568 20.5692 7.70568 20.017C7.70568 19.4647 8.15339 19.017 8.70566 19.017C9.25794 19.017 9.70565 19.4647 9.70565 20.017Z"
                                                    fill="currentColor"
                                                ></path>
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M21.1664 6.66667H7.44731L7.18443 4.67432C7.02155 3.432 5.96318 2.5019 4.70956 2.5H2.83332C2.37309 2.5 2 2.8731 2 3.33333C2 3.79357 2.37309 4.16667 2.83332 4.16667H4.70829C5.12491 4.1673 5.4777 4.47733 5.53202 4.89167L6.79876 14.4923C6.96283 15.7441 8.0355 16.6774 9.29863 16.6666L18.0998 16.6667C19.2946 16.6897 20.3479 15.8418 20.5838 14.654L21.9835 7.66362C22.0868 7.1479 21.6923 6.66667 21.1664 6.66667ZM8.45117 14.275L7.66721 8.33333H20.1497L18.9493 14.328C18.8704 14.7252 18.5193 15.0079 18.1157 15.0002L9.29156 15C8.86345 15.0036 8.5059 14.6925 8.45117 14.275Z"
                                                    fill="currentColor"
                                                ></path>
                                                <path
                                                    d="M14.5 9.5C14.5 9.22386 14.2761 9 14 9C13.7239 9 13.5 9.22386 13.5 9.5V11H12C11.7239 11 11.5 11.2239 11.5 11.5C11.5 11.7761 11.7239 12 12 12H13.5V13.5C13.5 13.7761 13.7239 14 14 14C14.2761 14 14.5 13.7761 14.5 13.5V12H16C16.2761 12 16.5 11.7761 16.5 11.5C16.5 11.2239 16.2761 11 16 11H14.5V9.5Z"
                                                    fill="currentColor"
                                                    stroke="currentColor"
                                                    stroke-width="0.3"
                                                ></path>
                                            </svg>
                                        </button>
                                    </div>
                                ) : (
                                    card?.link_buy && (
                                        <>
                                            {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? (
                                                <button disabled className={`btn-buy card-btn disable`}>
                                                    {t('common_card_out')}
                                                </button>
                                            ) : (
                                                <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                    {t('common_card_buy')}
                                                </p>
                                            )}
                                        </>
                                    )
                                )}
                                {card?.link_more && (
                                    <Link
                                        className="btn-more card-btn"
                                        href={
                                            ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale)
                                                ? card?.link_more
                                                : `${card?.link_more}${
                                                      String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                                  }utm_source=scenario+page&utm_medium=Pillar`
                                        }
                                        target="_blank"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'select_product',
                                            list_name: t('secH_title'),
                                            product_name: card.title,
                                            button_name: t('common_card_more'),
                                        }}
                                    >
                                        {t('common_card_more')}
                                    </Link>
                                )}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
